import React, { useEffect, useState } from 'react';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import { useQuery } from '@tanstack/react-query';
import { getPerformaInvoiceById, getSPBillById } from '../services/api/implementation/impl';
import { useLocation, useParams } from 'react-router-dom';
import { useSmartBack } from '../../shared/navigation';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import NoDataFound from '../components/layout/NoDataFound';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Header from '../../shared/components/layout/Header';
import Layout from '../components/layout/AppLayout';
import Loader from '../../shared/components/ui/Loader';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import SPOverview from './SPOverview';

const PayableItems = () => {
  const userId = Cookies.get('userId');
  const { id } = useParams();
  const { collapsed } = useSidebar();
  const { state } = useLocation();
  const from = state?.from;
  const { onBack } = useSmartBack({ fallback: '/builder/accounts/payables' });

  const {
    data: SPBillItems,
    refetch: refetchSPBillItems,
    isLoading
  } = useQuery({
    queryKey: ['spbillitems', id, from],
    queryFn: () => getSPBillById(id),
    enabled: !!id && from === 'payables'
  });

  useEffect(() => {
    if (from === 'payables') {
      refetchSPBillItems();
    } else {
      refetchPerformaInvoiceItems();
    }
  }, [from, id]);

  const {
    data: PerformaInvoiceItems,
    refetch: refetchPerformaInvoiceItems,
    isLoading: isLoadingPerformaInvoice
  } = useQuery({
    queryKey: ['performainvoiceitems', id, from],
    queryFn: () => getPerformaInvoiceById(id),
    enabled: !!id && from === 'performaInvoice'
  });

  useEffect(() => {
    mixpanel.track('SP Bills List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  const InvoiceFormat = ['id', 'name', 'workType', 'amount'];

  const SPBillData =
    from === 'payables'
      ? SPBillItems?.billTaskMapping?.map((item) =>
          transformData(
            {
              ...item,
              id: item.id,
              name: item?.task?.name,
              workType: item?.task?.workType?.name,
              amount: item?.amount
            },
            InvoiceFormat
          )
        )
      : PerformaInvoiceItems?.billTaskMapping?.map((item) =>
          transformData(
            {
              ...item,
              id: item.id,
              name: item?.task?.name,
              workType: item?.task?.workType?.name,
              amount: item?.amount
            },
            InvoiceFormat
          )
        );

  return (
    <>
      <Loader isVisible={isLoading || isLoadingPerformaInvoice} />
      {/* Main content */}
      <Layout>
        {/* Header */}
        <div
          className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
          <Header data={{ name: `Payable > Items` }} backArrow={true} onBack={onBack} />
        </div>

        <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw]' : ''}`}>
          <div className="w-full flex flex-col  z-5 bg-gray-100">
            {/* Grid */}

            <GridWrapper width={100}>
              <div className="table-container mt-[6rem] ">
                <SPOverview
                  data={from === 'payables' ? SPBillItems : PerformaInvoiceItems}
                  from={from}
                />
                <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;
            }
            .table-container > div {
              height: auto !important;
            }
          `}</style>{' '}
                {SPBillData && SPBillData?.length > 0 && (
                  <>
                    <Table
                      headers={['Task Name', 'Work Type', 'Amount']}
                      data={SPBillData}
                      identifier={'id'}
                      isViewEnable={false}
                      isEditEnable={false}
                      isDeleteEnable={false}
                    />{' '}
                  </>
                )}
              </div>
            </GridWrapper>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default PayableItems;
